import { RouterProvider } from 'react-router';
import { ErrorBoundary } from './ErrorBoundary';
import { AppProviders } from './providers';
import { router } from './router';

/**
 * Composition root.
 *
 * ErrorBoundary sits OUTSIDE the providers deliberately: if a provider itself
 * throws during initialisation, the boundary must still be mounted to catch it.
 * Nesting it inside would leave that case rendering a blank page.
 */
export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
